<div class="sidenav-component" @fadeInLeft>
  <!-- Navbar -->
  <div class="clp-sidebar" [ngClass]="{ '-collapsed': barIsCollapsed }">
    <div class="brand-section">
      <img
        class="navbar-brand-logo"
        *ngIf="
          organizationService.currentOrganization &&
          organizationService.currentOrganization.logoUrl
        "
        [src]="organizationService.currentOrganization.logoUrl" />
      <div
        class="evo-product QUALITY"
        *ngIf="
          organizationService.currentOrganization &&
          !organizationService.currentOrganization.logoUrl
        "
        [hidden]="barIsCollapsed"></div>
      <span
        [ngbTooltip]="organizationService.currentOrganization.name"
        container="body"
        placement="top"
        [hidden]="barIsCollapsed">
        {{ organizationService.currentOrganization.name }}
      </span>
      <!-- Collapse toggle inline (expanded state) -->
      <div class="collapse-toggle" *ngIf="!barIsCollapsed" (click)="toggleNavbar()" [ngbTooltip]="'Ocultar barra lateral'" placement="right" container="body">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round">
          <rect x="3" y="4" width="18" height="16" rx="2" ry="2" />
          <line x1="8" y1="4" x2="8" y2="20" />
        </svg>
      </div>
    </div>
    <!-- Collapse toggle (collapsed state) - between logo and menu -->
    <div class="collapse-toggle-collapsed" *ngIf="barIsCollapsed" (click)="toggleNavbar()" [ngbTooltip]="'Expandir barra lateral'" placement="right" container="body">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round">
        <rect x="3" y="4" width="18" height="16" rx="2" ry="2" />
        <line x1="8" y1="4" x2="8" y2="20" />
      </svg>
    </div>
    <div class="navigation-tabs">
      <!--@ Navigation section -->
      <nav class="nav flex-column mt-4">
        <div *ngFor="let navTabItem of navigationMenus">
          <hr *ngIf="navTabItem.id === 'administrative'" />
          <app-sidebar-menu-component
            [(activeNav)]="activeNavId"
            [barIsCollapsed]="barIsCollapsed || barIsExpanding"
            [sidebarMenu]="navTabItem">
          </app-sidebar-menu-component>
        </div>
      </nav>
    </div>
  </div>

  <div class="import-limit" [hidden]="barIsCollapsed"></div>

  <div class="update-version" *ngIf="versionService.newVersionAvailable && !barIsCollapsed">
    <h6>Nova versão disponível!</h6>
    <p>
      Atualize para a versão
      <b class="text-primary">{{ versionService.newVersion }}</b> para ter
      acesso às últimas funcionalidades.
    </p>
    <div class="d-flex justify-content-between">
      <button
        class="btn btn-primary btn-sm"
        (confirm)="updateVersion()"
        evolloConfirmDangerAction
        title="Atualizar versão"
        text="Você está prestes a atualizar para uma nova versão. Alterações não salvas podem ser perdidas, deseja continuar?">
        Atualizar agora
      </button>
      <button class="btn btn-sm">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>

  <div class="quality-version" *ngIf="versionService.config && !barIsCollapsed">
    <span>Quality</span>

    <span
      class="version-clickable"
      (click)="openChangeNotesModal()"
      ngbTooltip="Ver notas de atualização"
      container="body"
      placement="top">
      v{{ versionService.config.version }}
    </span>
  </div>
</div>
